<template>
    <li class="dropdown dropdown-extended dropdown-notification fade-in" id="header_notification_bar">
        <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown" data-hover="dropdown"
           data-close-others="true" title="Menu de notifications">
            <i class="icon-bell"></i>
            <span class="badge badge-default" style="background-color: orange;" v-if="notifications.not_readed != 0">
                {{ notifications.not_readed }}
            </span>
        </a>
        <ul class="dropdown-menu dropD fade-in">
            <li>
                <a href="/notifications" class="btn default green-stripe">
                    <span class="bold uppercase">Tout voir</span>
                </a>
            </li>
            <li>
                <ul class="dropdown-menu-list scroller" style="height: 250px;">
                    <li v-if="notifications.not_readed != 0" v-for="notification in notifications.notifications">
                        <a href="/notifications" class="btn">
                            <p style="font-style: italic;">{{ notification.created_at }} : </p>
                            <span>{{ notification.title }}</span>
                        </a>
                    </li>
                </ul>
            </li>
        </ul>
    </li>
</template>

<script>
export default {

  name: 'Notification',
  async mounted() {
    this.getNotifications().then((res) => {
        this.notifications = res
    })  
  },
  data () {
    return {
        notifications: {
            not_readed: 0
        },
    }
  },
  methods: {
    async getNotifications() {
        const res = await axios.get('/notifications/get')
        return await res.data
    }
  }
};
</script>

<style lang="css" scoped>
</style>
